/*
 * GLOBAL THEME VARS
 */
var loader = $(".ajax-load");